export const formatNumber = (number) => {
  if (number) {
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return null
  }
}
